import { useDispatch } from "react-redux";
import { meetActions } from "../store/slices/meet_slice/meetslice";
import { deviceState, MessageModel, ParticipantDetails, participantVideoRender, sharingState } from "./models/meetModal";
import _ from "lodash";
// import store from "../store/redux-store/root_store";
import { SCREENSHARE_INFO } from "../constants/reducer_names";
import { screenShareReducerAction } from "../store/slices/screenshare_slice/screensharedata";
import { storeVideoSliceAction } from "../store/slices/storeVideo/storeVideoData";
import { actionTypes, meetActionTypes, Types } from "./action/action";
import { EndCall } from "ccaas_videomeet_sdk/lib/ccassCall";
import { mediaAction } from "../store/slices/mediaslices/mediaslice";
import jwt_decode from "jwt-decode";
import { LoginActions } from "../store/slices/authentication_slice/login_slice";
import { LocalStorage } from "../custom_hooks/localStorageKeys";
import { SetItemInStorage,GetItemFromStorage } from "../custom_hooks/useStorage";
import { updateToParticipants, videoCallService } from "./service/videoCallService";
import store from "../store/redux-store/root_store"
import axios from "axios";
import moment from "moment";
import { config } from "./constant";
import { SpeechDetech } from "../services/speechdetect";
import { meetService } from "../services/meetService";
import { toast } from "../annotation";
import { CallServices, MeetServices } from "./service/apiServices";
import callChatService from "../base/service/chatService";


let isrecording: boolean = false;
let streams: any = [];
let videos: any = [];
let userPosition: number = 1;
let previous_xaxis: number = 0;
var audioStream = new MediaStream();
let rowCount: number = 0;
// export function VideoCommon(dispatch:any,navigate:any){
export const versioDetection = (dispatch: any) => {
  console.log("versioDetection", dispatch)
  try {
    const { userAgent } = navigator
    let brwsrMatch: any = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []
    let brwsrName: any;
    if (/trident/i.test(brwsrMatch[1])) {
      brwsrName = /\brv[ :]+(\d+)/g.exec(userAgent) || []
      return `IE ${brwsrName[1] || ''}`
    }
    if (brwsrMatch[1] === 'Chrome') {
      brwsrName = userAgent.match(/\b(OPR|Edge)\/(\d+)/)
      if (brwsrName !== null) {
        return brwsrName.slice(1).join(' ').replace('OPR', 'Opera')
      }
      brwsrName = userAgent.match(/\b(Edg)\/(\d+)/)
      if (brwsrName !== null) {
        return brwsrName.slice(1).join(' ').replace('Edg', 'Edge (Chromium)')
      }
    }
    brwsrMatch = brwsrMatch[2] ? [brwsrMatch[1], brwsrMatch[2]] : [navigator.appName, navigator.appVersion, '-?']
    brwsrName = userAgent.match(/version\/(\d+)/i)
    if (brwsrName !== null) {
      brwsrMatch.splice(1, 1, brwsrName[1])
    }
    console.log("brwsrMatch[0]", brwsrMatch)
    // dispatch(meetActions.updateBrowserType({browserType:brwsrMatch[0] , browserVersion:brwsrMatch[1]}))

    store.dispatch({
      type: meetActionTypes.BROWSER_TYPE,
      payload: {
        browserType: brwsrMatch[0],
        browserVersion: brwsrMatch[1]
      }
    });

  } catch (error) {
    console.log(error, "Browser-Version :-")
  }
}


export const updateSockMeetDetails = (message: any, connstatus?: string, eventName?: string, dispatch?: any) => {
  console.log("updateSockMeetDetails calling", message);
  const meetingDetails = message.meetingdetails;
  const socketid = message.socketid;
  let deviceInfo = meetingDetails.devicesInfo;
  let joinedParticipantList: Array<ParticipantDetails> = [];
  let joinedParticipantListDup: Array<ParticipantDetails> = [];
  let joinedParticipantListHost: Array<ParticipantDetails> = [];
  let waitingRoomList: Array<ParticipantDetails> = [];
  let waitingRoomListCopy: Array<ParticipantDetails> = [];
  let enableRecordingList: Array<ParticipantDetails> = [];
  let ccUserList: Array<ParticipantDetails> = [];


  if (!_.isEmpty(deviceInfo)) {
    let participantsList: Array<ParticipantDetails> = Array.isArray(Object.keys(deviceInfo)) &&
      Object.values(deviceInfo).length > 0 ? Object.values(deviceInfo) : [];
    const deviceid = GetItemFromStorage('deviceid') || '';
    participantsList.forEach((user: ParticipantDetails) => {
      if (user.status === "joined" || user.status === "disconnected") {
        if (user.conId === socketid && user.status === "disconnected" && !user.conId.includes("_screenshare")) {

          // setTimeout(()=>leaveSocketMeetDetails(message,joinedParticipantListDup,joinedParticipantListHost,
          //   waitingRoomList,enableRecordingList,deviceid,currentDeviceInfo),2000);
          user.status = "leave";
          //joinedParticipantList.push(user);


        }
        if (user.status === "joined") {
          joinedParticipantList.push(user);
          joinedParticipantListDup.push(user);
        }
      }
      if (user.status === "joined" && user.isHost === false) {
        joinedParticipantListHost.push(user);
      }
      if (user.moveToWaitingRoom === true && user.status === "inWaitingroom") {
        waitingRoomList.push(user);
        waitingRoomListCopy.push(user);
      }
      if (user.closedCaption === true) {
        ccUserList.push(user);
      }
      if (user.isRecordingAllowed === false && user.moveToWaitingRoom === false
        && user.isHost === false && user.status === "joined") {
        enableRecordingList.push(user);
      }
    });


    let currentDeviceInfo: any | {} = {};
    if (!_.isEmpty(deviceInfo) && deviceid && !_.isEmpty(deviceInfo[deviceid])) {
      currentDeviceInfo = deviceInfo[deviceid];
    }
    let connectionStatus = connstatus;
    if (!connectionStatus) {
      connectionStatus = 'connected';
    }
    if (waitingRoomList.length > 0 && currentDeviceInfo.isHost && eventName === "movetowaitroom") {
      // dispatch(meetActions.socketJoin({joinUser:true}))

      throwWaitingRoom(true);
    }
    if (message?.isConnected) {
      // dispatch(meetActions.updateConnectState({connstatus:message?.isConnected}))
      store.dispatch({
        type: meetActionTypes.UPDATE_CONN_STATUS,
        payload: {
          connstatus: message?.isConnected
        }
      });
    }

    joinedParticipantList.sort(function compare(a: any, b: any) {
      let dateA: any = new Date(a.joinedTime);
      let dateB: any = new Date(b.joinedTime);
      return dateA - dateB;
    });
    joinedParticipantList.reverse();
    let cindex: number = _.findIndex(joinedParticipantList, { deviceid: currentDeviceInfo?.deviceid });
    if (cindex !== -1 && cindex !== 1) {
      let currentdetails = joinedParticipantList[cindex];
      joinedParticipantList.splice(cindex, 1);
      joinedParticipantList.splice(1, 0, currentdetails);
    }

    // store.dispatch({
    //   type: Types.OPEN_CHAT_PARTICIPANTS,
    //   payload: {
    //     chatPartListTemp:participantsList
    //   }
    // });

    // dispatch(meetActions.updateSocketMeetDetails( {
    //     sockmeetDetails: message.meetingdetails,
    //     isError: { message: '' },
    //     isSuccess:{ message: '' },
    //     activeParticipantList:joinedParticipantList,
    //     activeParticipantListWH: joinedParticipantListHost,
    //     waitingRoomList: waitingRoomList,
    //     recordingEnabledList:enableRecordingList,
    //     currdeviceid: deviceid,
    //     currdeviceinfo: currentDeviceInfo,
    //     ccUserList: ccUserList
    //   })
    // );



    store.dispatch({
      type: meetActionTypes.SOCKET_MEETING_DETAILS,
      payload: {
        sockmeetDetails: message.meetingdetails,
        isError: { message: '' },
        isSuccess: { message: '' },
        activeParticipantList: joinedParticipantList,
        activeParticipantListWH: joinedParticipantListHost,
        waitingRoomList: waitingRoomList,
        recordingEnabledList: enableRecordingList,
        currdeviceid: deviceid,
        currdeviceinfo: currentDeviceInfo,
        ccUserList: ccUserList
      }
    });
    // setTimeout(()=>{
    //   let {activeParticipantList}=store.getState().meetingReducer;
    //   console.log("update reducerr",activeParticipantList);
    // },2000)

    /*     if(isDisconnected){
          setTimeout(()=>leaveSocketMeetDetails(message,joinedParticipantListDup,joinedParticipantListHost,
            waitingRoomList,enableRecordingList,deviceid,currentDeviceInfo),5000);
          isDisconnected = false;
        } */

  }

};
export const sipCallEnd = () => {
  try {
    let { currdeviceinfo } = store.getState().meetingReducer || [];
    let videoRenderList: any = store.getState().storeVideo.participantList || [];
    let currentUserData: any = _.find(videoRenderList, { participants: currdeviceinfo.conId });
    if (currentUserData !== undefined) {
      EndCall(currentUserData.userAgent);
      let vedioStream = currentUserData.stream;
      const tracks = vedioStream.getTracks();
      tracks.forEach(function (track: any) {
        track.stop();
      });
    }
  }
  catch (e) { console.log("error is", e); }
};


export const stopScreenSharing = (dispatch?: any) => {
  try {
    let { participantList, midValue } = store.getState().storeVideo || [];
    let { currdeviceinfo } = store.getState().meetingReducer || [];
    const {annotationEnable,conId}:any=store.getState().sharingReducerState;
    // const virtualBGState:any = store.getState().VirtualBG;
    let jsonData: any = {};
    jsonData.shape = actionTypes.SCREENSHARING_STATUS;
    jsonData.status = false;
    jsonData.conId =currdeviceinfo.conId + '_screenshare';
    let input = {
      sipId:currdeviceinfo.conId + '_screenshare',
      message: jsonData,
      type: 'stop'
    };
    videoCallService.sendScreenShare(input);
    



    let index: number = -1;
    index = participantList.findIndex((elem: any) => elem.participants === conId);
    if (index !== -1) {
      let stream = participantList[index].stream;
      stream.getTracks().forEach((track: any) => (track.kind === "video" ? track.stop() : ''));
      participantList.splice(index, 1);
      storeParticipantVideo(participantList, midValue, "Ready");
      // dispatch(storeVideoSliceAction.participantvideolist({participantList:participantList}))
      // dispatch(storeVideoSliceAction.participantVideoInfo({midValue:midValue,callStatus:"Ready"}))

    }


    // if (virtualBGState.dupImage) {
    //   updateVirtualBGRedux(virtualBGState.dupImage, virtualBGState.dupImgIndex);
    // }

  }
  catch (e) { console.log("e is", e); }
};



const singlePrompt = async () => {
  return new Promise(async (resolve, reject) => {
    let errorCallback = (error: any) => {
      if ((error.name === 'NotAllowedError') || (error.name === 'PermissionDismissedError') || (error.name === 'NotFoundError') || error.name === "NotReadableError") {
        // toggleVideoDelay(true);
        reject("there is no device");
      }
    };
    var constraints: any = {
      audio: true,
      video: {
        width: 1280, height: 720, zoom: false
      },
      aspectRatio: { exact: 1.7777777778 },
      facingMode: "environment"
    };
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      await navigator.mediaDevices.getUserMedia(constraints)
        .then((stream: any) => {
          console.log(constraints, "constraints==");

          resolve(stream);
        }, errorCallback);
    }
  });
}

export const askPermission = async (dispatch?: any) => {
  let mediaDeviceInfo:deviceState=store.getState().mediaDevice;
  let data: any = singlePrompt();

  await data.then((stream: any) => {


    let audioStream: any = new MediaStream();
    audioStream.addTrack(stream.getAudioTracks()[0]);
    let videoStream: any = new MediaStream();
    videoStream.addTrack(stream.getVideoTracks()[0]);

    // setMeetInfo((prevState: any) => ({ ...prevState, audioStream: audioStream }));


    // dispatch(meetActions.updateAudioStream({audioStream:audioStream}))
    console.log(audioStream, "audioStream==");
    console.log("inside ask permission",mediaDeviceInfo);

    updateAudioStream(audioStream);
    const tracks = stream.getTracks();
    tracks.forEach(function (track: any) {
      // handlePermission(track.kind, track);
    });
    // var audio: any = document.querySelector("audio");
    // audio.srcObject = audioStream;
    deviceDetailInfo("audio", true, "success");



    // setMeetInfo({ ...meetInfo, audioStream: audioStream, audio: true, isLoading: false });
    updateVedioStream(videoStream);
    // dispatch(meetActions.updateVideoStream({videoStream:videoStream}))
    var video: any = document.getElementById("joinPageVideo");
    if (video) {
      video.srcObject = stream;
      video.autoplay = true;
    }

    mediaDeviceAdded("add");
    deviceDetailInfo("video", true, "success");
    // setTimeout(function () {
    // setMeetInfo({ ...meetInfo, videoStream: videoStream, video: true, isLoading: false });
    // toggleVideo(true);
    // toggleVideoDelay(true);
    // }, 800);
  })
    .catch((e: any) => {
      console.log("e error is", e);
      // // toggleVideoDelay(true);
      // startVideo();
      // startAudio();

    })

};

export const deviceDetailInfo = (medium: string, status: boolean, err: string) => {
  let mediaDeviceInfo: deviceState = store.getState().mediaDevice;
  let data: any = {};
  if (medium === 'video') {
    console.log("status>>",status,"error>>>",err);
    data.isAudio = mediaDeviceInfo.isAudio;
    data.isAudioStatus = mediaDeviceInfo.isAudioStatus;
    data.isVideo = status;
    data.isVideoStatus = err;
  }
  else {
    data.isAudio = status;
    data.isAudioStatus = err;
    data.isVideo = mediaDeviceInfo.isVideo;
    data.isVideoStatus = mediaDeviceInfo.isVideoStatus;
  }

  // dispatch(mediaAction.mediaDeviceInfo({data}))

  store.dispatch({
    type: actionTypes.MEDIADEVICEINFO,
    payload: data
  });
};


export const mediaDeviceAdded = async (status: string) => {

  try {
    // if(!isDeviceAdded) return;
    let meetingReducer = store.getState().meetingReducer || [];
    if (meetingReducer.connstatus === 'connected') {
      let videoRenderList: any = store.getState().storeVideo.participantList || [];
      let { currdeviceinfo } = store.getState().meetingReducer || [];
      let index: number = -1;
      index = videoRenderList.findIndex((elem: any) => elem.participants === currdeviceinfo.conId);
      if (index !== -1) {
        navigator.mediaDevices.enumerateDevices()
          .then(async function (devices) {
            const devicesListAudioInput: any = [];
            const devicesListVideoInput: any = [];
            await devices.forEach(function (device) {
              if (device.deviceId !== "default" && device.deviceId !== "communications") {
                if (device.kind === "audioinput") {
                  devicesListAudioInput.push({ deviceId: device.deviceId, label: device.label });
                }
                if (device.kind === "videoinput") {
                  devicesListVideoInput.push({ deviceId: device.deviceId, label: device.label });
                }
              }
            });

            let audioTrack: any = (videoRenderList[index].stream).getAudioTracks()[0] || [];
            let videoTrack: any = (videoRenderList[index].stream).getVideoTracks()[0] || [];
            let constrain: any = {};
            constrain.audio = false;
            constrain.video = false;

            if (audioTrack.readyState === "ended" || audioTrack.muted === true || audioTrack.length === 0) {
              if (devicesListAudioInput.length >= 1) {
                constrain.audio = true;
              }
            }
            if (videoTrack.readyState === "ended" || videoTrack.muted === true || videoTrack.length === 0) {
              if (devicesListVideoInput.length >= 1 && currdeviceinfo.video) {

                if (audioTrack.readyState === "ended" || audioTrack.muted === true || audioTrack.length === 0) {
                  if (devicesListAudioInput.length >= 1) { constrain.audio = true; }
                }

                // constrain.frameRate = { ideal: 12, max: (sUsrAg.indexOf('Firefox') > -1) ? 30 : 15 };
                constrain.video = { width: 640, height: 480 };
              }
            }

            if (constrain.audio || constrain.video) {
              deviceMediaChanged(index, constrain, currdeviceinfo);
            }
          })
          .catch(function (err: any) {
            // isDeviceAdded = true;
            console.log(err.name + ": " + err.message);
          });
      }
    }
  }
  catch (e: any) {
    // isDeviceAdded = true;
    console.log("error is", e);
  }
};

export const deviceMediaChanged = async (index: any, constrain: any, currdeviceinfo: any) => {
  try {
    let { participantList, midValue, callStatus } = store.getState().storeVideo || [];
    let stream = await navigator.mediaDevices.getUserMedia(constrain);
    var pc: any = participantList[index].userAgent.sessionDescriptionHandler.peerConnection;
    pc.getSenders().forEach((sender: any, index: number) => {
      if (sender.track) {
        if (sender.track.kind === "audio" && constrain.audio && index === 0) {
          sender.replaceTrack(stream.getAudioTracks()[0]);
        }
        if (sender.track.kind === "video" && constrain.video && index === 1) {
          sender.replaceTrack(stream.getVideoTracks()[0]);
        }
      }
    });

    setTimeout(function () {
      if (currdeviceinfo.mute && constrain.audio) {
        pc.getSenders().forEach(function (sender: any) {
          var track = sender.track;
          if (track) {
            if (track.kind === 'audio') track.enabled = false;
          }
        });
      }
    }, 100);

    let sipVideo: any = participantList[index];
    let oldStream: any = sipVideo.stream;
    if (constrain.audio) {
      var audioTrack = oldStream.getAudioTracks()
      if (audioTrack.length > 0) {
        oldStream.removeTrack(audioTrack[0]);
        let newAudioStream = stream.getAudioTracks()[0];
        oldStream.addTrack(newAudioStream);
        // toastStatus("Device Changed: "+newAudioStream.label.replace('Default - ', ''));
        // var speechEvents:any;
        //var options = { threshold:-50 };

        // let cloneMedia = audioStream.clone();
        // speechEvents = hark(cloneMedia, options);
        // detectActiveSpeaker(speechEvents,stream);
        // let speakingEvents:any = new SpeechDetech(cloneMedia, {passThrough: false});

        // detectActiveSpeaker(speakingEvents);

      }
    }
    if (constrain.video) {
      var videoTrack = oldStream.getVideoTracks() || [];
      if (videoTrack.length > 0) {
        oldStream.removeTrack(videoTrack[0]);
        let newVideoStream = stream.getVideoTracks()[0];
        oldStream.addTrack(newVideoStream);
        // toastStatus("Device Changed: "+newVideoStream.label.replace('Default - ', ''));
      }
    }
    sipVideo.stream = oldStream;
    participantList[index] = sipVideo;
    // storeParticipantVideo(participantList, midValue, callStatus);
    // isDeviceAdded = true;
  } catch (err) {
    // isDeviceAdded = true;
    console.log("error is ", err);
  }
};

export const downloadRecFile = (url: any) => {
  let filePath = url;
  let fileName = url.substring(url.lastIndexOf('/') + 1);
  var xhr = new XMLHttpRequest();
  xhr.open("GET", filePath, true);
  xhr.responseType = "blob";
  console.log(xhr.response);

  xhr.onload = function () {
    var urlCreator = window.URL || window.webkitURL;
    var imageUrl = urlCreator.createObjectURL(this.response);
    var tag = document.createElement("a");
    tag.href = imageUrl;
    tag.download = fileName;
    document.body.appendChild(tag);
    tag.click();
    document.body.removeChild(tag);
    toast('Recording File download successfully');
  };
  xhr.addEventListener('error', function () {
    toast(' File not found');
  });
  xhr.send();
}

export const fetchBrowserTpeRec = () => {
  let browserType = "";
  if ((navigator.userAgent.indexOf("Firefox") !== -1) && (navigator.userAgent.indexOf("Chrome") < 0)) {
    browserType = "Firefox";
  } else if ((navigator.userAgent.indexOf("Safari") !== -1) && (navigator.userAgent.indexOf("Chrome") < 0)) {
    browserType = "Safari";
  } else if ((navigator.userAgent.indexOf("Edge") !== -1) || (navigator.userAgent.indexOf("Edg") !== -1)) {
    browserType = "Edge";
  } else if ((navigator.userAgent.indexOf("Opera") !== -1) || (navigator.userAgent.indexOf("OPR") !== -1)) {
    browserType = "Opera";
  } else if ((navigator.userAgent.indexOf("Trident") !== -1) || (navigator.userAgent.indexOf("MSIE") !== -1)) {
    browserType = "Explorer";
  }
  else if (navigator.userAgent.indexOf("Chrome") !== -1) {
    browserType = "Chrome";
  } else {
    browserType = "";
  }

  return `${browserType}@${navigator.platform}`
}


export const getUserInfo = (token: string, dispatch: any, data1?: any, type?: any) => {
  console.log("tokennn", token)
  return new Promise(async (resolve, reject) => {
    if (token) {
      let userDetails = await decodeJWT(token);
      console.log("userDetailsuserDetails", userDetails);
      if (userDetails) {
        let data: any = userDetails;
        if (type === "guest") {
          data.ext = data1.ext;
          data.domain_name = data1.domain_name;
          data.dp_password = data1.dp_password;
          data.video_domain_name = data1.video_domain_name;
        };
        dispatch(LoginActions.login({ token: token, loginUserDetails: data }));
        SetItemInStorage(LocalStorage.USER_DETAILS, userDetails);
      } else {
        dispatch(LoginActions.login({ token: token, loginUserDetails: {} }));
      }


    } else {
      reject(false);
    }
  });
};

const decodeJWT = async (data: any) => {
  var decoded = jwt_decode(data);
  return decoded
}

export const  toDataUrl = (url:any, callback:any) => {
  var xhr = new XMLHttpRequest();
  xhr.onload = function() {
    var reader = new FileReader();
    reader.onloadend = function() {
      callback(reader.result);
    };
    reader.readAsDataURL(xhr.response);
  };
  xhr.open('GET', url);
  xhr.responseType = 'blob';
  xhr.send();
};

export const updateVirtualBGRedux = (image:string, imgIndex:number, status?:boolean) =>{
  const { currdeviceinfo } = store.getState().meetingReducer;
  const virtualBGState:any = store.getState().VirtualBG;
  console.log("virtualBGStatevirtualBGState>>",virtualBGState);
  let videoRenderList: any = store.getState().storeVideo.participantList || [];
  let index: number = -1;
  index = videoRenderList.findIndex((elem:any) => elem.participants === currdeviceinfo.conId);
  if (imgIndex === 0 && virtualBGState.imgIndex!==0) {
    console.log("enteredddddddddd");
    var pc: any = videoRenderList[index].userAgent.sessionDescriptionHandler.peerConnection;
    pc.getSenders().forEach(async(sender: any) => {
      if (index !== -1) {
        if(sender.track){
        if (sender.track.kind === "video") {
          let stream: any = videoRenderList[index].stream;
          sender.replaceTrack(stream?.getVideoTracks()[0]);
          // pipeline?.cleanUp();
        }
      }
      }
    });
  }

  store.dispatch({
    type: meetActionTypes.UPDATE_VIRTUAL_BG,
    payload: {
      image,
      imgIndex
    }
  });
  
  if(!status)
    store.dispatch({
      type: meetActionTypes.UPDATE_TEMP_VIRTUAL_BG,
      payload: {
        dupImage:image,
        dupImgIndex:imgIndex
      }
    });
};

export const updateBGV = (tflite:any,bodyPix:any) =>{
  store.dispatch({
    type: meetActionTypes.UPDATE_VIRTUAL_TEMP,
    payload: {
      bodyPix: bodyPix,
      tflite: tflite
    }
  });
};

export const updateJoinArrowKey = (key:any) => {
  store.dispatch({
    type: meetActionTypes.UPDATE_ARROW_KEY,
    payload: {
      arrowKey:key
    }
  })
}


export const sendingReinvite = async (participantDetail: any, dispatch: any) => {
  console.log("dispatchdispatch123", dispatch, "participantDetailparticipantDetail", participantDetail)
  let { participantList }: any = store.getState().storeVideo || [];
  let { midValue }: any = store.getState().storeVideo;
  let { currdeviceinfo, iceState }: any = store.getState().meetingReducer || [];
  console.log("sendingReinvite is calling", participantList, "smidValuemidValue", midValue);

  try {

    console.log("participantDetail >>>>>>>", participantDetail);
    let currentDeviceInfoIndex = participantDetail.findIndex((elem: any) => elem.conId === currdeviceinfo.conId);

    console.log("currentDeviceInfoIndex >>>>>>", currentDeviceInfoIndex);
    let { callStatus } = store.getState().storeVideo || [];

    console.log(participantDetail, "participantDetail11111===");

    if (participantDetail && currentDeviceInfoIndex !== -1) {
      store_Status("Waiting");
      console.log(callStatus, "callStatus change to waiting ===");

      // dispatch(storeVideoSliceAction.callStatus({callStatus : "Waiting"})); 
      let { currdeviceinfo, iceState } = store.getState().meetingReducer || [];
      let isSendReinvite: boolean = false;
      let mid = midValue;
      let userSelfIndex: number = -1;

      let currentActivePeople: any = [...participantList].filter((participatStore: any) =>
        participantDetail.some((updatedList: any) =>
          participatStore.participants === updatedList.conId));
      console.log("currentActivePeoplecurrentActivePeople", currentActivePeople)


      if (currentActivePeople.length !== 0 && (currentActivePeople.length !== participantList.length)) {
        participantList = currentActivePeople;
        isSendReinvite = true;
      }
      console.log(participantDetail, "participantDetail====");
      userSelfIndex = participantList.findIndex((elem: any) => elem.participants === currdeviceinfo.conId);
      console.log(userSelfIndex, "userSelfIndex===");
      if (userSelfIndex !== -1) {
        let pc: any = participantList[userSelfIndex].userAgent.sessionDescriptionHandler.peerConnection;
        console.log("Self peer connection is >>>>>", pc);
        if (pc) {
          for (let i = 0; i < participantDetail.length; i++) {
            let index: number = -1;
            index = participantList.findIndex((elem: any) => {
              console.log("elemelem", elem);
              return elem.participants === participantDetail[i].conId
            });


            if (index === -1 && pc.signalingState !== "closed") {
              let mid_Value: any = [];
              if (participantDetail[i].conId.includes("_screenshare")) {
                mid_Value.push(mid++);
                pc.addTransceiver("video", { direction: 'recvonly' });
              }
              else {
                mid_Value.push(mid++);
                mid_Value.push(mid++);
                pc.addTransceiver("audio", { direction: 'recvonly' });
                pc.addTransceiver("video", { direction: 'recvonly' });
              }
              let sipVideo = {
                participants: participantDetail[i].conId,
                mid: mid_Value,
                stream: '',
                userAgent: participantList[userSelfIndex].userAgent
              };
              console.log("sipVideosipVideo", sipVideo)
              participantList.push(sipVideo);
              console.log(participantList, "participantList===>");

              isSendReinvite = true;
            }
          }
          console.log("before calling", isSendReinvite);
          if (isSendReinvite && participantList.length !== 0) {
            storeParticipantVideo(participantList, midValue, "Waiting");
            // dispatch(storeVideoSliceAction.participantvideolist({participantList:participantList}))
            // dispatch(storeVideoSliceAction.participantVideoInfo({midValue: mid, callStatus :"Waiting"}));

            let sessionDescription = await pc.createOffer();
            let removedCodec: any = removeUnwantedCodec(sessionDescription.sdp);
            sessionDescription.sdp = removedCodec;
            pc.setLocalDescription(sessionDescription);
            let query: any = { sdp: sessionDescription.sdp, participantList: participantDetail, socketId: currdeviceinfo.conId };
            videoCallService.sendUpdatedSdp(query);

          }
          else {
            console.log("call state changing to Ready");
            storeParticipantVideo(participantList, midValue, "Ready");
            // dispatch(storeVideoSliceAction.participantvideolist({participantList:participantList}))
            // dispatch(storeVideoSliceAction.participantVideoInfo({midValue: mid, callStatus :"Ready"}));
          }
        }

      }
    }
  }
  catch (e: any) {
    console.log("error is e", e);
    storeParticipantVideo(participantList, midValue, "Ready");
    // dispatch(storeVideoSliceAction.participantvideolist({participantList:participantList}))
    // dispatch(storeVideoSliceAction.participantVideoInfo({midValue: midValue, callStatus :"Ready"}));
  }
};

const removeUnwantedCodec = (message: any) => {

  // let videoBandwidth = 64;
  // message = message.replace("a=mid:1", "a=mid:1\r\nb=AS:" + videoBandwidth);
  message = message.replace(/sendrecv/g, 'recvonly');
  message = message.replace("a=recvonly", "a=sendonly");
  message = message.replace("a=recvonly", "a=sendonly");
  let mainSDP = message;
  message = message.split('\r\n');
  let sdp = '';
  let listOfcodec = [];
  let defaultAudioCodec = ['opus'];
  let defaultVideoCodec = ['VP8', 'VP9'];

  for (var i = 0; i < message.length; i++) {
    if (message[i].includes('m=audio')) {
      let payload_data = message[i].split("SAVPF ")
      let payload = payload_data[1].split(" ");
      let codec = "";

      if (payload_data[1].length > 0) {
        for (let j = 0; j < payload.length; j++) {
          for (let k = 0; k < defaultAudioCodec.length; k++) {
            if (mainSDP.includes(payload[j] + " " + defaultAudioCodec[k])) {
              listOfcodec.push(payload[j]);
              codec += (codec === "") ? payload[j] : " " + payload[j];
            }
          }
        }
      }
      let finalData = payload_data[0] + "SAVPF " + codec;
      sdp += finalData + '\r\n';
    }
    else if (message[i].includes('m=video')) {
      let payload_data = message[i].split("SAVPF ");
      let payload = payload_data[1].split(" ");
      let codec = "";
      for (let j = 0; j < payload.length; j++) {
        for (let k = 0; k < defaultVideoCodec.length; k++) {
          if (mainSDP.includes(payload[j] + " " + defaultVideoCodec[k])) {
            listOfcodec.push(payload[j]);
            codec = (codec === "") ? payload[j] : codec + " " + payload[j];
            if (mainSDP.includes(payload[j + 1] + " rtx")) {
              listOfcodec.push(payload[j + 1]);
              codec += " " + payload[j + 1];
            }
          }
        }
      }
      let finalData = payload_data[0] + "SAVPF " + codec;
      sdp += finalData + '\r\n';
    }
    else if (message[i].includes('a=rtpmap')) {
      let codec = (message[i].split('a=rtpmap:')[1]).split(" ")[0];
      if (listOfcodec.indexOf(codec) !== -1) { sdp += message[i] + '\r\n'; }
    }
    else if (message[i].includes('a=rtcp-fb')) {
      let codec = (message[i].split('a=rtcp-fb:')[1]).split(" ")[0];
      if (listOfcodec.indexOf(codec) !== -1) { sdp += message[i] + '\r\n'; }
    }
    else if (message[i].includes('a=fmtp')) {
      let codec = (message[i].split('a=fmtp:')[1]).split(" ")[0];
      if (listOfcodec.indexOf(codec) !== -1) { sdp += message[i] + '\r\n'; }
    }
    else {
      sdp += message[i];
      if (i !== message.length - 1) sdp += '\r\n';
    }
  }

  return sdp;

};

export const throwWaitingRoom = (joinUser: boolean) => {
  store.dispatch({
    type: meetActionTypes.SOCKET_JOIN,
    payload: {
      joinUser: joinUser
    }
  });
};

export const storeParticipantVideo = async(data: any, mid: number, status: string) => {

 await store.dispatch({
    type: actionTypes.PARTICIPANT_VIDEO_INFO,
    payload: {
      participant: data,
      midValue: mid,
      callStatus: status
    }
  });
};

export const storeTranscript = (data: any, loader?: any) => {
  let { scrollTrans } = store.getState().closeCaption;
  store.dispatch({
    type: Types.TRANSCRIPTS_LIST,
    payload: {
      oriTranscript: data,
      transcripts: data,
      scrollTrans: scrollTrans,
      transLoader: loader
    }
  });
}

export const trunketName = (str: any) => {
  if (str.length > 15) {
    return str.substring(0, 15) + "...";
  }
  return str;

}

export const activeSpeakerDetect = (message: any) => {
  try {
    let { pin, activeSpeaker } = store.getState().meetingReducer;
    if (!activeSpeaker[message.speaker_socketId] && message.message === "speaking") {
      let activeParticipant: any = {};
      activeParticipant[message.speaker_socketId] = true;
      store.dispatch({
        type: meetActionTypes.PIN_UPDATE,
        payload: {
          pin: pin,
          activeSpeaker: activeParticipant
        }
      });
    }
  }
  catch (e: any) { console.log("e is ", e); }
};

export const formatTime = (timeInMilliseconds:any) => {
  let hrs:any=0;let mins:any=0;let sec:any=0;
 hrs= moment.duration(timeInMilliseconds).hours() < 9 ? `0${moment.duration(timeInMilliseconds).hours() }` : moment.duration(timeInMilliseconds).hours() 
 mins= moment.duration(timeInMilliseconds).minutes() < 9 ? `0${moment.duration(timeInMilliseconds).minutes()}` : moment.duration(timeInMilliseconds).minutes()
 sec=moment.duration(timeInMilliseconds).seconds() < 9 ? `0${moment.duration(timeInMilliseconds).seconds()}`: moment.duration(timeInMilliseconds).seconds()
   return `${hrs}:${mins}:${sec}`
};

export const setRecTimer=(time:any,pausetime:any,elptime:any)=>{
  store.dispatch({
  type: meetActionTypes.REC_TIMER,
  payload: {recTimer:time,pauseTime:pausetime,elapsedTime:elptime}
})
}


export const  formatTransferTimer=(time: any) =>{
  const seconds = Math.floor(time / 1000) % 60;
  const minutes = Math.floor(time / 1000 / 60) % 60;
  return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
}

export const setcloseCaptionText = (data: any) => {
  let { ccBtns, showOriginalText, fontSize } = store.getState().closeCaption;
  store.dispatch({
    type: meetActionTypes.CLOSE_CAPTION,
    payload: {
      closeCaptionText: data,
      ccBtns: ccBtns,
      showOriginalText: showOriginalText,
      fontSize: fontSize

    }
  });


}

export const sendAiAssistData=(cc_data:any)=>{
   const meetingDetails: any = store.getState().meetingReducer;
let data:any=
{
sessionId:meetingDetails.meetingDetails.uuid,
domainId: meetingDetails.meetingDetails.agentDetails.domain_id.toString(),
ext: meetingDetails.meetingDetails.agentDetails.ext,
message:JSON.stringify(cc_data) ,
messageId:Date.now(),
planId:GetItemFromStorage(LocalStorage.PLAN_ID).toString(),
to: `${meetingDetails.meetingDetails.agentDetails.domain_id}_${meetingDetails.meetingDetails.agentDetails.ext}`,
}
 callChatService.io.emit('video_channel_agent_assist', data);
}

export const updateAudioStream = (stream: any) => {
  store.dispatch({
    type: meetActionTypes.UPDATE_AUDIO_STREAM,
    payload: {
      audioStream: stream
    }
  });
};

export const updateVedioStream = (stream: any) => {
  store.dispatch({
    type: meetActionTypes.UPDATE_VIDEO_STREAM,
    payload: {
      videoStream: stream
    }
  });
};

export const store_Status = (status: string) => {
  store.dispatch({
    type: actionTypes.CALL_STATUS,
    payload: status
  });

  console.log(status, "CALL_STATUS===");

};

export const storeCallStatus = (status: boolean) => {
  store.dispatch({
    type: actionTypes.CALL_WAITING_STATUS,
    payload: status
  });

  console.log(status, "CALL_WAITING_STATUS===");
};

export const updatedParticipatList = (data: any) => {
  console.log(data, "updated participant list===");
  // debugger;
  store.dispatch({
    type: actionTypes.CALL_SYNC_STORE,
    payload: data
  });
};

export const throwReconnect = (instatus: boolean) => {
  store.dispatch({
    type: meetActionTypes.UPDATE_IN_STATUS,
    payload: {
      instatus: instatus
    }
  });
};

export const throwLoading = (loading: boolean) => {
  console.log(loading, "loading===");
  // debugger;
  store.dispatch({
    type: meetActionTypes.SOCKET_LOADING,
    payload: {
      isLoading: loading
    }
  });
  return true;
};

// export const toastStatus = (message: any) => {
//   store.dispatch({
//     type: meetActionTypes.SOCKET_ERROR,
//     payload: { isSuccess: { message: message }, isError: { message: '' } }
//   });
//   setTimeout(() => {
//     store.dispatch({
//       type: meetActionTypes.SOCKET_ERROR,
//       payload: { isSuccess: { message: '' }, isError: { message: '' } }
//     });
//   }, 3000);
// };


export const participantAddRemove = (status: string, socketId: string) => {
  if (isrecording) { re_ArrangeVideo(); }
};

export const checkVideoRender = (userInfo: ParticipantDetails) => {
  if (userInfo.conId.includes("_screenshare")) { return false; }
  else {
    let stored_Video: any = store.getState().storeVideo;
    let connID: string = userInfo.conId;
    let videoData: participantVideoRender = _.find(stored_Video.participantList, { participants: connID });
    if (videoData !== undefined) {
      if (videoData.stream !== '') { return true; }
      else { return false; }
    }
    else { return false; }
  }
};

export const videoWidthHeightCalc = (participantCount: number) => {
  let Margin = 4;
  let Scenary = document.getElementById('root');
  if (Scenary) {

    let Width = window.outerWidth - (Margin * 2);
    let Height = window.outerHeight - (Margin * 2);
    let max = 0;

    let i = 1;
    while (i < 5000) {
      let w = Area(i, participantCount, Width, Height, Margin);
      if (w === false) {
        max = i - 1;
        break;
      }
      i++;
    }
    max = max - (Margin * 2);
    let data: any = { width: Math.round(max), height: Math.round(max * 0.75) };
    return data;
  }
};

export const getAxis = (idx: any, width: number, height: number) => {
  var x = 0; var y = 0;

  if (streams.length === 1) {
    x = Math.round((window.outerWidth - width) / 2);
    y = Math.round((window.outerHeight - height) / 2);
  }
  else if (streams.length === 2) {
    y = Math.round((window.outerHeight - height) / 2);
    if (idx === 0) {
      x = Math.round((window.outerWidth - (width * streams.length)) / 2);
    }
    else {
      x = width + 2;
    }
  }
  else {
    let numberOfVideoTail: number = Math.floor(window.outerWidth / width);
    if (userPosition === 1) {
      x = Math.round((window.outerWidth - (width * numberOfVideoTail)) / 2);
    }
    else { x = previous_xaxis + width; }
    y = rowCount * height;
    previous_xaxis = x;

    if (userPosition === numberOfVideoTail) { userPosition = 1; rowCount++; }
    else { userPosition++; }
    if (videos.length === idx + 1) { userPosition = 1; rowCount = 0; }
  }

  return { x: x, y: y };
};

export const getVideo = (stream: any) => {
  var video: any = document.createElement('video');

  if ('srcObject' in video) {
    video.srcObject = stream;
  } else {
    video.src = URL.createObjectURL(stream);
  }

  video.muted = true;
  video.volume = 0;

  video.width = stream.width || 640;
  video.height = stream.height || 480;
  video.play();
  return video;
};

export const Area = (increment: number, count: number, width: number, height: number, margin: number = 10) => {
  var w;
  let i = w = 0;
  let h = increment * 0.75 + (margin * 2);
  while (i < (count)) {
    if ((w + increment) > width) {
      w = 0;
      h = h + (increment * 0.75) + (margin * 2);
    }
    w = w + increment + (margin * 2);
    i++;
  }
  if (h > height) return false;
  else return increment;
};

export const updateCCLang = (lang: any) => {
  let { expandHide } = store.getState().closeCaption;
  store.dispatch({
    type: meetActionTypes.CC_LANG,
    payload: {
      ccLang: lang.lang,
      expandHide:expandHide
    }
  });

    setcloseCaptionText([]);
};
export const updateCloseCaptionLang = (data: any) => {
  updateCCLang(data);
  }

export const updateFullScreen = (data:boolean) =>{
  store.dispatch({
    type: meetActionTypes.FULL_SCREEN,
    payload: {
      fullScreenAgent:data,
      fullScreenCustomer:false
    }
  });
};

export const re_ArrangeVideo = () => {
  try {
    let videoRenderList: any = store.getState().storeVideo.participantList || [];
    let { activeParticipantList } = store.getState().meetingReducer || [];
    videos = [];
    streams = [];
    activeParticipantList.forEach((elem: any) => {
      if (checkVideoRender(elem) && elem.status === "joined") {
        let videoData: any = _.find(videoRenderList, { participants: elem.conId });
        if (videoData) {
          let data: any = {};
          data.stream = videoData.stream;
          data.name = elem.name;
          data.isvideo = elem.video;
          data.conId = elem.conId;
          streams.push(data);
        }
      }
    });

    let poss: any = videoWidthHeightCalc(streams.length) || [];
    let width = poss.width;
    let height = poss.height;
    streams.forEach(function (data: any, idx: any) {
      if (data.stream.getVideoTracks().length) {
        var video: any = getVideo(data.stream);
        let axis = getAxis(idx, width, height);
        video.x = axis.x;
        video.y = axis.y;
        video.width = width;
        video.height = height;
        video.name = data.name;
        video.isvideo = data.isvideo;
        video.conId = data.conId;
        videos.push(video);
      }
    });
  }
  catch (e: any) { console.log("error is", e); }
};


export const storeUserAgent = (UA: any) => {
  store.dispatch({
    type: actionTypes.CREATE_CALL_UA,
    payload: UA
  });
  inviteBinding(UA);
};

export const storePrevUserAgent = (UA: any) => {
  store.dispatch({
    type: actionTypes.MULTI_INVITE_CHECK,
    payload: UA
  });
};

function inviteBinding(UA: any) {
  UA.on("registrationFailed", function (reason: any) {
    console.log("Registration Failed***********", reason);
  });
}

export const fileupload = (data: any, meeting_id:string,condId:string, type:string) =>{
  const accessToken = GetItemFromStorage(LocalStorage.ACCESS_TOKEN);
  let formData = new FormData();
  formData.append("meeting_id", meeting_id);
  formData.append("doc", data);

  axios.post<any>(`${config().UPLOAD_MEETING_FILES}`, formData , {
    headers: {
      appId: config().APPID,
      appSecret: config().AppSECRET,
      Authorization: accessToken,
    }},)
  .then((data: any) => {
    console.log(data,"data======");
    
    if(data.data.statusCode===200 && data.data.files.length>0){
    console.log(data.data.files,"data.files====");
    
       videoCallService.sendFilePrivate(condId,data.data.files[0]);
      
    }
  }).catch((err:any)=>{
    // throwError("API Error");
    console.log(err,"err====");
    
    throwLoading(false);
  });
};

export const storeConversationChatDetails = (message: any) => {
  if('conversations' in message.meetingdetails){
    const conversations = Array.isArray(message.meetingdetails.conversations)
&& message.meetingdetails.conversations.length>0 ?
      message.meetingdetails.conversations.filter((value:any)=>{
        return value.isPublic===true;
      }): [];
    store.dispatch({
      type: meetActionTypes.STORE_CONVERSATION,
      payload: {
        message: conversations
      }
    });
  }
};



export const imageFormatType =
  [ "image/png" , "image/jpeg" , "image/jpg", "image/jfif", "image/svg", "image/webp",'image/gif',
    'image/x-icon','image/x-xpixmap','image/x-xwindowdump',"image/vnd.xiff" ];
export const videoFormat =[ "video/mpeg" , "video/mp4" , "video/quicktime" , "video/x-msvideo" ,
  "video/quicktime", "video/ogg" ,"application/ogg","video/3gpp", "video/3gpp2" , "video/webm","video/x-sgi-movie"];
   
export const mp3Formats = ["audio/mpeg", "audio/x-pn-realaudio", "application/x-pn-realaudio",
  "audio/ogg", "audio/x-aiff",
  "audio/basic","audio/midi","audio/webm","audio/aac","audio/x-wav","audio/3gpp","audio/3gpp2","audio/x-wav"];

export const wordMimeFormats =[ "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
  "application/vnd.ms-word.document.macroEnabled.12",
  "application/vnd.ms-word.template.macroEnabled.12"];

  export const pdfFormats = ["pdf", "application/pdf"];
  
export const pptMimeFormats = ['application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.openxmlformats-officedocument.presentationml.template',
  'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  'application/vnd.ms-powerpoint.addin.macroEnabled.12',
  'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
  'application/vnd.ms-powerpoint.template.macroEnabled.12',
  'application/vnd.ms-powerpoint.slideshow.macroEnabled.12'];

export const excelMimeFormats =[ "application/vnd.ms-excel" ,
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
  "application/vnd.ms-excel.sheet.macroEnabled.12",
  "application/vnd.ms-excel.template.macroEnabled.12",
  "application/vnd.ms-excel.addin.macroEnabled.12",
  "application/vnd.ms-excel.sheet.binary.macroEnabled.12",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"];

export const zipMimeFormats =["application/zip", "application/octet-stream",
  "application/x-zip-compressed", "multipart/x-zip", "application/x-rar-compressed", "application/octet-stream"];
  
  export const openChatWindow = (activeParticipantList: any, deviceId: string) => {
    const filteredhost:any = _.find(activeParticipantList,
      { deviceid: deviceId });
      setTimeout(function () {
        videoCallService.getChats(filteredhost?.conId, "private");
        iterateSoreChat(filteredhost);
        updateToParticipants(filteredhost);
      }, 100);
  }

  export const iterateSoreChat = (toDeviceid: any) => {
    const { meetingDetails,currdeviceinfo } = store.getState().meetingReducer;
    const { uuid} = meetingDetails;
    let storeChat = GetItemFromStorage('chat') || '';
    
    if(storeChat){
      const parsedChat:any = storeChat?JSON.parse(storeChat):{};
      if(parsedChat && parsedChat[uuid]){
      
        if(toDeviceid && toDeviceid.deviceid){
          if(parsedChat[uuid]["private"][toDeviceid.deviceid]){
            const privateChatList = Object.keys(parsedChat[uuid]["private"][toDeviceid.deviceid]);
            if( privateChatList.length>0){
              privateChatList.forEach((value:any)=>{
                if(parsedChat[uuid]["private"][toDeviceid.deviceid][value]){
                  parsedChat[uuid]["private"][toDeviceid.deviceid][value] = true;
                  parsedChat[uuid]["private"][toDeviceid.deviceid]["count"]=0;
                }
              });
            }
          }
        }
      }
      SetItemInStorage('chat',JSON.stringify(parsedChat));
    }
  };



  export const readCountStoreChat = (msg: MessageModel) => {
    let storeChat = GetItemFromStorage('chat')  || '';
    let parseMChat= storeChat?JSON.parse(storeChat):'';
    const { meetingDetails,currdeviceinfo } = store.getState().meetingReducer;
    const { uuid} = meetingDetails;
    const deviceid = GetItemFromStorage('deviceid') || '';
    if(!storeChat){
      const chatObj:any = {};
      chatObj[uuid]={};
      chatObj[uuid]["public"] = {count:0};
      chatObj[uuid]["private"]={};
      SetItemInStorage('chat',JSON.stringify(chatObj));
    } else if(!parseMChat[uuid]){
      parseMChat[uuid]={};
      parseMChat[uuid]["public"] = {count:0};
      parseMChat[uuid]["private"]={};
      SetItemInStorage('chat',JSON.stringify(parseMChat));
    }
    storeChat = GetItemFromStorage('chat') || '';
    const parsedChat: any = JSON.parse(storeChat);
   
    if(storeChat && msg.isPublic===false  && deviceid!==msg.from_deviceId
      && deviceid===msg.to_deviceId){
      if(parsedChat[uuid] && parsedChat[uuid]["private"]){
        if(!parsedChat[uuid]["private"][msg.from_deviceId]){
          parsedChat[uuid]["private"][msg.from_deviceId] ={count:0};
        }
        if(parsedChat[uuid]["private"][msg.from_deviceId][msg.msg_Id]===undefined)
          parsedChat[uuid]["private"][msg.from_deviceId]["count"]++;
  
        if(!parsedChat[uuid]["private"][msg.from_deviceId][msg.msg_Id])
          parsedChat[uuid]["private"][msg.from_deviceId][msg.msg_Id] =
          currdeviceinfo.deviceid===msg.from_deviceId?true:false;
  
        if(parsedChat[uuid]["private"][currdeviceinfo.deviceid])
          parsedChat[uuid]["private"][currdeviceinfo.deviceid]["count"]=0;
      }
    }
    SetItemInStorage('chat',JSON.stringify(parsedChat));
  };

  export const openChat = (toggle:boolean) =>{
    store.dispatch({
      type: meetActionTypes.CHAT_WINDOW_OPEN,
      payload: {
        isopenChat: toggle
      }
    });
  };

  export const storeChatConvo=(message:any)=>{
    store.dispatch({
      type:meetActionTypes.CHAT_RECEIVE_ARRAY,
      payload:{
        chatConvo:message
      }
    })
  }

  export const setVerifyModals=(enable:boolean,req:boolean,accept:any,decline:any,recog:any,faceCapture:any)=>{
          store.dispatch({
        type:meetActionTypes.VERIFICATION_MODAL,
        payload:{
          verifyModalEnable:enable,verifyReqModal:req,verifyAcceptModal:accept,declineModal:decline,faceRecogModal:recog,faceCaptureModal:faceCapture
        }
      })
    }
      export const setDocModal=(docmodal:boolean,det:any,recDet:any,capture:boolean,details:boolean)=>{
          store.dispatch({
        type:meetActionTypes.DOC_MODAL,
        payload:{
         docModal:docmodal,
         docSendDetails:det,
         docReceiveDetails:recDet,
         docCaptureModal:capture,
         docDetailsModal:details
        }
      })
    }
  export const setVerificationDetails=(isstore:any,verify:any,face:any,docs:any,facedocs:any)=>{
      store.dispatch({
        type:meetActionTypes.FACE_VERIFICATION_DETAILS,
        payload:{
         isStore:isstore,isVerify:verify,isFace:face,isDocs:docs,isFaceDocs:facedocs
        }
      })
  }

    export const dataURLtoBlob=(dataURL: any) => {
    const parts = dataURL.split(';base64,');
    const contentType = parts[0].split(':')[1];
    const raw = window.atob(parts[1]);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);
    for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], { type: contentType });
}
  export const updateImage=(count:number,file:any,faceimg:any,docimage:any)=>{
    console.log("countcount",count);
     store.dispatch({
        type:meetActionTypes.FACE_VERIFICATION_IMG_INFO,
        payload:{
         imgCount:count,imgFile:file,faceImgUrl:faceimg,docImgUrl:docimage
        }
      })
  }

  export const setVerifyInitialState=()=>{
    setVerificationDetails(false,false,false,false,false);
    setVerifyModals(false,false,false,false,false,false)
     updateImage(0,{file1:"",file2:"",file3:"",file4:"",file5:""},"","")
     setVerifyMsg("","","",false)
     setDocModal(false,{},{},false,false)

  }
  export const setVerifyMsg=(success:string,err:string,content:string,processing:boolean)=>{
    store.dispatch({
      type:meetActionTypes.VERFICATION_MSG,
      payload:{
         verifySuccessMsg:success,
         verifyErrMsg:err,
         verifyContent:content,
         dataProcessing:processing
         
      }
    })
  }

  export const sendDocToNlp=(base64:any,file:any)=>{
   try{ const {isStore,imgFile,faceImgUrl,docSendDetails,docImgUrl,isVerify}:any=store.getState().verificationReducer;
    let {activeParticipantList,currdeviceinfo}:any=store.getState().meetingReducer;
         let remotedev: any = activeParticipantList.find((ele: any) => { return (ele.conId !== currdeviceinfo.conId && !ele.conId.includes("_screenshare")) })
            const formData = new FormData();
        formData.append('doc',file);
        formData.append('doc_type',docSendDetails.hasOwnProperty("type") ? docSendDetails?.type : "" );
        if(isStore){
          axios.post(`${config().DOC_UPLOAD_EXTRACT}`, formData).then((res: any) => {
         setDocModal(false,docSendDetails,{data:res.data,status:"New data"},false,true)
         setVerifyMsg("","", "Extracting document details",true)
                             setTimeout(
                              ()=>{ setVerifyMsg("","", "Data extraction completed.",true)
                              setTimeout(()=>{
                        let data:any={count:0,deviceid:remotedev?.deviceid,docImgUrl:base64,isImageCaptured:true,docReceiveDetails:{data:res.data.data}};
                        videoCallService.sendVerificationDetails(data);
                         setVerifyMsg("","", "",false)
                              },3000)
                             },3000)          
                  let updatedInfo: any = imgFile;
               updatedInfo = {
                 ...updatedInfo, [`file1`]: file
               };
               updateImage(0,updatedInfo,faceImgUrl,base64)
        })
           .catch((err:any)=>{
                    console.log("doc storage failure",err)
                  })}
        else{
 
          axios.post(`${config().DOC_VERIFICATION}`, formData).then((res: any) => {
                       let data:any={count:0,deviceid:remotedev.deviceid,docImgUrl:base64,isImageCaptured:true,docReceiveDetails:{data:res.data.extracted_data,status:res.data.results},verifyType:"docs"};
                        videoCallService.sendVerificationDetails(data);
                            let senddata:any={type:"docdetails",deviceid:remotedev.deviceid,docReceiveDetails:{data:res.data.extracted_data,status:res.data.results},docSendDetails,docImgUrl:base64};
                            videoCallService.sendVerificationRequestData(senddata);
                setDocModal(false,docSendDetails,{data:res.data.extracted_data,status:res.data.status},false,true)
                           let updatedInfo: any = imgFile;
               updatedInfo = {
                 ...updatedInfo, [`file1`]: file
               };
               updateImage(0,updatedInfo,faceImgUrl,base64)
                  })
                  .catch((err:any)=>{
                    console.log("doc verification failure",err)
                    let data:any={type:"failure", verifyType:"face",deviceid:remotedev?.deviceid};
                    videoCallService.sendVerificationRequestData(data);
                  })
        }}
        catch(err:any){
          
        }
  }

  export const uploadImage=(file:any,type:any)=>{
        try{
        const meetingDetails: any = store.getState().meetingReducer;
        const {verifyAttachments,docSendDetails,docReceiveDetails}:any=store.getState().verificationReducer;
        let existingData:any=[];
        let formData = new FormData();
        formData.append('doc', file ,`${meetingDetails.meetingDetails.agentDetails.customerNumber}_${JSON.stringify(meetingDetails.meetingDetails.agentDetails.customerDetails.coid)}_${JSON.stringify(meetingDetails.meetingDetails.agentDetails.domain_id)}_${type}`);
               CallServices.post(formData, "/chat_upload_file")
                 .then((response: any) => {
                   if (
                     response?.data?.statusCode === 200 &&
                     response?.data?.fileList.length > 0
                   ) {
                    if(type !== "face"){setDocModal(false,docSendDetails,docReceiveDetails,false,true)}
                    else{setVerifyMsg("","", "Face stored successfully",true)}
                    const today = new Date();

                        const day = String(today.getDate()).padStart(2, '0');
                        const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
                        const year = today.getFullYear();

                        const formattedDate = `${day}-${month}-${year}`;
                     if(verifyAttachments !== null){ existingData=verifyAttachments.filter((elem:any)=>{return elem.type !== type})}
                                          
                                          let data:any={type,files:response?.data?.fileList[0],createdBy:meetingDetails?.meetingDetails?.agentDetails?.username,createDate:formattedDate}
                                          existingData.push(data);
                    callAttachmentUpdateAPI(meetingDetails?.meetingDetails?.agentDetails?.customerDetails.coid,existingData,type);
                   } else {
                    setVerifyInitialState();
                    updateVerificationFailure("face")
                    toast("Invalid document detected. Please upload a valid and clear document")
                   }
                 })
                 .catch((error:any) => {
                    console.log("error",error)
                    setVerifyInitialState();
                    updateVerificationFailure("docs")
                    toast("Invalid document detected. Please upload a valid and clear document")
                 });
                }
                catch(err:any){
                  console.log("errrrr",err);
                     toast("Invalid document detected. Please upload a valid and clear document")
                     setVerifyInitialState();
                     updateVerificationFailure("docs")
                }
                }

  export const callAttachmentUpdateAPI=async(coid:any,attach:any,type:string)=>{
  let {meetingDetails,activeParticipantList,currdeviceinfo}:any=store.getState().meetingReducer;
  const {isFace,isFaceDocs,isDocs}:any=store.getState().verificationReducer;
      let remotedev: any = activeParticipantList.find((ele: any) => { return (ele.conId !== currdeviceinfo.conId && !ele.conId.includes("_screenshare")) })
  let data: any = {};
        data.coid = coid;
        data.domain_id = meetingDetails.agentDetails.domain_id;
        data.attachments = attach;
        await MeetServices.post(data, `/insert_videomeet_verification_attachments`).then((response: any) => {
          if (response?.data?.statusCode === 200) {
            setVerifyMsg("","","",false)
            if((type ==="face" && isFace) || ((type !=="face" && isDocs) ||(type !=="face" && isFaceDocs))){
              console.log("typeee",type,isFace,isDocs,isFaceDocs);
              setVerifyInitialState()
              let data:any={type:"complete", verifyType:type,deviceid:remotedev?.deviceid};
              videoCallService.sendVerificationRequestData(data);
            }
            else if(type ==="face" && isFaceDocs){
                  setVerifyModals(true,false,false,false,false,false);
              setDocModal(true,{},{},false,false);
            }
          }
        }
        )
          .catch((err: any) => {
            toast("Failed to save verification data. Please try again later");
            console.log("insert vm verification attachments failed", err);
          })

      }

      
            export const updateVerificationFailure=(type:any)=>{
                let {meetingDetails,activeParticipantList,currdeviceinfo}:any=store.getState().meetingReducer;
                    let remotedev: any = activeParticipantList.find((ele: any) => { return (ele.conId !== currdeviceinfo.conId && !ele.conId.includes("_screenshare")) })
        let senddata:any={type:"failure",verifyType:(type === "face" ? "face" : "docs"),deviceid:remotedev.deviceid, };
    videoCallService.sendVerificationRequestData(senddata);
  }
  export const getVideoSessionById = async (sessionId: any) => {
    try{
    return new Promise(async (resolve, reject) => {
      return MeetServices.get(sessionId,`get_videomeet_historyid`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
    }
catch(err:any){console.log("get videosession by id err",err)}
  };